import moment from 'moment'
import DateTime from 'react-datetime'
import styled from 'styled-components'

import {
  Box,
  Button,
  Dropdown,
  Flex,
} from 'app/components/design-system-components'
import { ArrowDropDownRounded } from 'app/components/design-system-components/icons/navigation'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import { DropdownBodyWrapper } from 'app/sm/team_viewing_preference/states_dropdown'
import { DATE_WITH_DASH } from 'app/utils/datetime/helpers'

const StyledDatePicker = styled(DateTime)`
  .pickerInput {
    display: none !important;
  }
`

const StyledDropdownButton = styled(Button)`
  border: 1px solid #808080;
  line-height: 0.9 !important;
  align-items: center;
  padding: 6px 12px !important;
`

const DateDropdown = ({
  date,
  labelRenderer,
  onDateChangedHandler,
  width = '202px',
  height = '50px',
  disable = false,
  format = DATE_WITH_DASH,
  closeOnChange,
  mr = 4,
  fontSize,
  defaultStyle = true,
  ...props
}) => {
  const ButtonRenderer = defaultStyle ? StyledDropdownButton : Button
  return (
    <Dropdown
      mr={mr}
      className="dateDropdown"
      triggerWrapperComponent={({ dropdownControls }) => (
        <ButtonRenderer
          className="dateDropdownButton"
          variant="outline"
          onClick={() => dropdownControls.toggle()}
          width={width}
          height={height}
          fontSize={fontSize}
        >
          <Flex justifyContent="space-between" alignItems="center">
            <Box>{labelRenderer(date)}</Box>
            <Box
              as={ArrowDropDownRounded}
              ml={theme.space[3] + 'px'}
              fontSize={theme.fontSizes.pExtraLarge18}
            />
          </Flex>
        </ButtonRenderer>
      )}
      dropdownComponent={({ dropdownControls }) => (
        <DropdownBodyWrapper>
          <StyledDatePicker
            open={true}
            dateFormat={format}
            timeFormat={false}
            inputProps={{
              placeholder: '',
              className: `pickerInput`,
              readOnly: disable,
            }}
            onChange={(date) => {
              onDateChangedHandler(moment(date, format).format(format))
              closeOnChange && dropdownControls.close()
            }}
            value={date && moment(date, format).format(format)}
          />
        </DropdownBodyWrapper>
      )}
      {...props}
    />
  )
}

export default DateDropdown
